import { Icon } from "@oysterhr/ui"
import { ReactNode } from "react"
import classNames from "classnames"

import { TodoTasksTaskState } from "@oysterhr/schema"
import { TodoTasksTaskDetailsFragment } from "../../../../gql/graphql"

type TaskItemProps = {
  /**
   * The task that will be used in this Item.
   * We use this to check for the status of the task, to know which icon to render
   */
  task: TodoTasksTaskDetailsFragment
  /**
   * If the task contains an action that the user can do, you can use this property to render it
   */
  actionNode?: ReactNode
  /**
   * The translated text of the task. The text you pass here should already be translated
   */
  taskName: ReactNode

  /**
   * A small description that is shown below the task name
   */
  taskDescription?: ReactNode

  /**
   * You can use this property if you want to change the style of the task when the action is disabled
   * Take into account that you still need to disable the action on the node itself
   */
  disabled?: boolean
}

const iconMap: Record<TodoTasksTaskState, JSX.Element> = {
  [TodoTasksTaskState.Pending]: <Icon name="SpinnerGap" size="xs" />,
  [TodoTasksTaskState.Blocked]: <Icon name="SpinnerGap" size="xs" />,
  [TodoTasksTaskState.Hidden]: <Icon name="SpinnerGap" size="xs" />,
  [TodoTasksTaskState.Completed]: <Icon name="Check" size="xs" />,
}

export function TaskItem({ task, taskName, taskDescription, actionNode, disabled }: TaskItemProps) {
  if (task.state === TodoTasksTaskState.Hidden) return null

  return (
    <li className="flex min-h-8 w-full flex-row items-center space-x-4">
      <div className="flex flex-1 flex-row space-x-1.5">
        <div
          className={classNames({
            "text-gray-200": disabled,
          })}
        >
          {iconMap[task.state]}
        </div>
        <div
          className={classNames("flex flex-col", {
            "text-gray-200": disabled,
          })}
        >
          <span className={classNames("text-black")}>{taskName}</span>
          {taskDescription && <span className="text-sm text-gray-400">{taskDescription}</span>}
        </div>
      </div>
      {actionNode}
    </li>
  )
}
